module.exports = __webpack_public_path__ + "static/media/esl.3d8c5551.svg";